import { render, staticRenderFns } from "./BlogDetailsHome.vue?vue&type=template&id=7dfc973f&scoped=true"
import script from "./BlogDetailsHome.vue?vue&type=script&lang=js"
export * from "./BlogDetailsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc973f",
  null
  
)

export default component.exports